import SvgSprite from 'components/html-elements/SvgSprite';
import React from 'react';
import { When } from 'react-if';
import { Tab } from 'react-bootstrap';
import app from 'srcJs/App';
import { NavLink } from 'components/router/NavLink';

var ToolsContent = function ToolsContent(_ref) {
  var tools = _ref.tools;

  if (!tools) {
    return null;
  }

  var renderItem = function renderItem(item) {
    var content = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
      className: "text-truncate"
    }, item.label), /*#__PURE__*/React.createElement(When, {
      condition: item.target
    }, /*#__PURE__*/React.createElement(SvgSprite, {
      id: "external-link",
      size: 12,
      additionalClassName: "color-b9b9ba ml-4p"
    })));

    if (item.target) {
      return /*#__PURE__*/React.createElement("a", {
        href: item.url,
        className: "d-flex align-items-center",
        target: "_blank",
        rel: "noreferrer"
      }, content);
    }

    return /*#__PURE__*/React.createElement(NavLink, {
      to: item.url,
      className: "d-flex align-items-center"
    }, content);
  };

  var items = tools.map(function (item) {
    return /*#__PURE__*/React.createElement("li", {
      key: item.url
    }, renderItem(item));
  });
  return /*#__PURE__*/React.createElement(Tab.Pane, {
    eventKey: "tools"
  }, /*#__PURE__*/React.createElement("div", {
    className: "fs-22 mb-4 pb-3"
  }, app.tForReact('base_menu', 'Tools')), /*#__PURE__*/React.createElement("ul", {
    className: "desktop-nav-list"
  }, items));
};

export { ToolsContent };